// import {
//   PPSI_NEW_THRESHOLD_DAYS,
//   PPSI_UPDATED_THRESHOLD_DAYS
// } from '../../settings';

function getThreshold(offset) {
  const threshold = new Date();
  threshold.setDate(threshold.getDate() - offset);
  return threshold;
}

function getPublishDate(ppsi) {
  const { actualPublishDate, modifyDate } = ppsi;
  const ppiModified = actualPublishDate === modifyDate;
  return ppiModified ? new Date(actualPublishDate) : new Date(modifyDate);
}

function isPublishedWithin(days, ppsi) {
  const publishDate = getPublishDate(ppsi);
  const thresholdDate = getThreshold(days);
  return publishDate > thresholdDate;
}

function isNewPpsi(ppsi,dateDuration) {
    const { actualPublishDate, modifyDate } = ppsi;
  const ppiModified = actualPublishDate === modifyDate;
  let isFirstVersion = ppsi.version === 1;
  if(isFirstVersion && ppiModified === false){
    isFirstVersion = false;
  }
  const isPublishedRecently = isPublishedWithin(dateDuration, ppsi);
  return isFirstVersion && isPublishedRecently;
}

function isUpdatedPpsi(ppsi,dateDuration) {
  const { actualPublishDate, modifyDate } = ppsi;
  const ppiModified = actualPublishDate === modifyDate;
  const getVersion = ppsi.version;
  let isSecondOrLaterVersion = ppsi.version !== 1;
  if(getVersion === 1 && ppiModified === false){
    isSecondOrLaterVersion = true;
  }
  const isPublishedRecently = isPublishedWithin(
    dateDuration,
    ppsi
  );
  return isSecondOrLaterVersion && isPublishedRecently;
}

export { isNewPpsi, isUpdatedPpsi };
